import { render, staticRenderFns } from "./ypAdd.vue?vue&type=template&id=313afc01&scoped=true"
import script from "./ypAdd.vue?vue&type=script&lang=js"
export * from "./ypAdd.vue?vue&type=script&lang=js"
import style0 from "./ypAdd.vue?vue&type=style&index=0&id=313afc01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313afc01",
  null
  
)

export default component.exports